import { Button, ButtonProps } from "@outschool/backpack";
import React, { useState } from "react";

import PageModal from "../PageModal";
import { LeaveWaitlistFormProps } from "./LeaveWaitlistForm";
import LeaveWaitlistModal from "./LeaveWaitlistModal";

type LeaveWaitlistButtonProps = ButtonProps & LeaveWaitlistFormProps;

export default React.forwardRef(LeaveWaitlistButton);

function LeaveWaitlistButton(
  {
    key,
    learner,
    activity,
    waitlistSeats,
    onClick,
    ...buttonProps
  }: LeaveWaitlistButtonProps,
  ref: React.Ref<any>,
) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <>
      <Button
        ref={ref}
        variant="link"
        onClick={(e: $TSFixMe) => {
          onClick?.(e);
          setOpen(true);
        }}
        {...buttonProps}
      >
        {buttonProps.title}
      </Button>
      <PageModal open={open} onClose={close}>
        <LeaveWaitlistModal
          key={key}
          learner={learner}
          activity={activity}
          waitlistSeats={waitlistSeats}
          close={close}
        />
      </PageModal>
    </>
  );
}
